/**
 * @voltxampere/ui — 24LC256 EEPROM (Sprint 45-5, placeholder)
 *
 * PLACEHOLDER. I2C bus simulation Sprint 47+ engine extension #4
 * ile aktif olur. Şu anki davranış `digital-gate` placeholder
 * (Sprint 43 MCU pattern reuse, gateFunction "NOT").
 *
 * Reference: Microchip 24LC256 — DIP-8 / SOIC-8. I2C EEPROM,
 * 256 Kbit (32 KByte), V_DD 1.7-5.5 V, write cycle 5 ms, endurance
 * 1M cycles, retention 200 yıl. Konfig save (Arduino sketch),
 * sensör log, kalibrasyon data.
 *
 *   Default mapping → digital-gate schemaType:
 *     gateFunction = "NOT"
 *     vHigh = 5
 *     vLow = 0
 *     threshold = 2.5
 *     propagationDelay = 1e-6  (1 µs typical I2C response)
 *
 * Engine zero-diff invariant honored — canonical `digital-gate`
 * engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const memory24lc256 = {
    id: "24lc256",
    nameTr: "24LC256 (I2C EEPROM 256Kbit, DIP-8, placeholder)",
    nameEn: "24LC256 (I2C EEPROM 256Kbit, DIP-8, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "24LC256",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "NOT",
        vHigh: 5,
        vLow: 0,
        threshold: 2.5,
        propagationDelay: 1e-6,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=memory-24lc256.js.map